import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
  FONT_SIZE_SMALL,
  FONT_WEIGHT_NORMAL_PP,
  HEADER_COLOR,
  HIGH_CONTRAST_TEXT_COLOR,
} from '@/styles/styleVariables';

type SpotsBlockProps = {
  spotsBlockMargin?: string;
};

type SpotsHeaderProps = {
  headerFontSize?: string;
  headerFontWeight?: number;
  headerPadding?: string;
};

type SpotsCardContainerProps = {
  col?: boolean;
  spotCardContainerWidth?: string;
};

type SpotLabelProps = {
  spotLabelWeight?: number;
  spotLabelWidth?: string;
  col?: boolean;
};

const SpotsBlock = styled.div<SpotsBlockProps>`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: ${({ spotsBlockMargin }) => spotsBlockMargin};
`;

const SpotsHeader = styled.h1<SpotsHeaderProps>`
  color: ${HEADER_COLOR};
  font-size: ${({ headerFontSize }) => headerFontSize};
  font-weight: ${({ headerFontWeight }) => headerFontWeight};
  padding: ${({ headerPadding }) => headerPadding};
  text-align: center;
  width: 100%;
`;

const spotsContainerInitialStyles = css`
  align-items: flex-start;
  display: flex;
  justify-content: space-evenly;
`;

const spotsContainerColStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const SpotsContainer = styled.div<Partial<SpotsCardContainerProps>>`
  ${({ col }) => (col ? spotsContainerColStyles : spotsContainerInitialStyles)};
`;

const SpotCardContainer = styled.div<SpotsCardContainerProps>`
  align-items: center;
  display: flex;
  flex-direction: ${({ col }) => (col ? 'row' : 'column')};
  width: ${({ spotCardContainerWidth }) => spotCardContainerWidth};
`;

const SpotLabel = styled.h3<SpotLabelProps>`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${({ spotLabelWeight }) =>
    spotLabelWeight || FONT_WEIGHT_NORMAL_PP};
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  text-align: ${({ col }) => (col ? 'start' : 'center')};
  width: ${({ spotLabelWidth }) => spotLabelWidth};
  ${({ col }) =>
    col &&
    css`
      padding-left: 0.813rem;
    `}
`;

export {
  SpotsBlock,
  SpotCardContainer,
  SpotLabel,
  SpotsContainer,
  SpotsHeader,
};
